// extracted by mini-css-extract-plugin
export default {"wrapper":"StudentWebinarRoom_wrapper__eevm6","streams":"StudentWebinarRoom_streams__0XgQz","chat":"StudentWebinarRoom_chat__wF-SJ"};